import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {PayPalScriptProvider, PayPalMessages, usePayPalScriptReducer} from '@paypal/react-paypal-js'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const Messages = ({price, placement}) => {
    const [{isPending}] = usePayPalScriptReducer()

    if (isPending) return

    return (
        <PayPalMessages
            amount={price}
            placement={placement}
            style={{
                layout: 'text',
                logo: {
                    type: 'primary',
                    position: 'right',
                },
                text: {
                    color: 'monochrome',
                },
            }}
        />
    )
}

Messages.propTypes = {
    price: PropTypes.number.isRequired,
    placement: PropTypes.string.isRequired,
}

const PaypalWidget = ({price, placement}) => {
    const {locale} = useMultiSite()
    const paymentsConfiguration = useCustomPreference('paymentsConfiguration')

    if (
        !paymentsConfiguration?.paypal?.clientId ||
        paymentsConfiguration?.paypal?.widgetEnabled !== 'true'
    )
        return

    return (
        <Box data-testid="paypal-placement">
            <PayPalScriptProvider
                options={{
                    clientId: paymentsConfiguration.paypal.clientId,
                    components: 'messages',
                    dataNamespace: 'paypal_sdk',
                    locale: locale?.id?.replace('-', '_'),
                }}
            >
                <Messages price={price} placement={placement} />
            </PayPalScriptProvider>
        </Box>
    )
}

PaypalWidget.propTypes = {
    price: PropTypes.number.isRequired,
    placement: PropTypes.string.isRequired,
}

export default PaypalWidget
